import { MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getCurrencies } from "../../services/currenciesService";

function extractCurrencies(payload) {
  const paginator =
    payload?.currencies ??
    payload?.data?.currencies ??
    payload?.data ??
    payload;

  if (Array.isArray(paginator?.data)) return paginator.data;
  if (Array.isArray(paginator)) return paginator;
  return [];
}

export function CurrencySelect({
  value,
  onChange,
  error = false,
  helperText = "",
  disabled = false,
  label = "Currency",
}) {
  const query = useQuery({
    queryKey: ["active-currency-options"],
    queryFn: () => getCurrencies({ page: 1, per_page: 100, is_active: 1 }),
    staleTime: 5 * 60 * 1000,
  });

  const currencies = useMemo(() => extractCurrencies(query.data), [query.data]);

  return (
    <TextField
      select
      fullWidth
      label={label}
      value={value || ""}
      onChange={onChange}
      disabled={disabled || query.isLoading || query.isError}
      error={error || query.isError}
      helperText={
        helperText ||
        (query.isLoading
          ? "Loading currencies..."
          : query.isError
            ? "Unable to load currencies."
            : !currencies.length
              ? "No active currencies available."
              : "")
      }
      sx={{
        "& .MuiInputBase-root": { minHeight: 38, borderRadius: 0, fontSize: "0.72rem" },
        "& .MuiInputLabel-root": { fontSize: "0.72rem" },
        "& .MuiFormHelperText-root": { mx: 0, fontSize: "0.63rem" },
      }}
    >
      <MenuItem value=""><em>Select currency</em></MenuItem>
      {currencies.map((currency) => (
        <MenuItem key={currency.id} value={currency.code}>
          {currency.code} — {currency.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
